import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import {
  ISSUE_BY_ID_DOCUMENT,
  ISSUE_BY_ID_FETCH_POLICY,
  toIssueSummary,
} from "./use-fetch-issue-by-id";
import type { Omittable } from "@salestrak/ui";

type UseIssueByIdOptions = Omittable<{
  skip?: boolean;
}>;

// Declarative companion to useFetchIssueById; shares its document/policy/cast.
export function useIssueById(issueId: string | undefined, options?: UseIssueByIdOptions) {
  const variables = useMemo(() => ({ issueId: issueId! }), [issueId]);

  const { data, loading, error } = useQuery(ISSUE_BY_ID_DOCUMENT, {
    variables,
    fetchPolicy: ISSUE_BY_ID_FETCH_POLICY,
    skip: !issueId || (options?.skip ?? false),
  });

  const issue = toIssueSummary(data);

  return { issue, loading, error };
}
